/** @jsx jsx */
import { ImgHTMLAttributes } from 'react';
import NumberFormat from 'react-number-format';
import styled from '@emotion/styled';
import { jsx } from '@emotion/core';

import { Text } from 'components';
import { ICustomTheme, IText } from 'interfaces';

const RewardText = styled(Text)(({ theme }: { theme: ICustomTheme }) => ({
  whiteSpace: 'nowrap',
  fontSize: theme.typography.body1.fontSize,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

const Img = styled('img')(({ theme }: { theme: ICustomTheme }) => ({
  width: 20,
  marginLeft: theme.spacing(1),
  verticalAlign: 'middle',
}));

export default function Value({
  value = 0,
  imgProps,
  textProps,
}: {
  value?: number;
  imgProps?: ImgHTMLAttributes<HTMLImageElement>;
  textProps?: IText;
}): JSX.Element {
  return (
    <RewardText fontWeight="bold" isParagraph={false} {...textProps}>
      <NumberFormat value={value} displayType="text" thousandSeparator=" " />
      {imgProps && <Img {...imgProps} />}
    </RewardText>
  );
}
